const { CONSTANTS } = require('../../../../config')

// ? ******************************************************************************************
// ? ******************************************************************************************

/**
 * @param {*} value
 * @param {number|null} bank
 * @returns {string|undefined}
 */
function accountNo (value, bank) {
  if (!bank) return value

  let val = value
  if (!val) return

  val = val
    .toString()
    .trim()
    .replace(/[^0-9]+/g, '')

  if (!val) return

  let clearingNoLength = 4
  if (
    CONSTANTS.SE.FIVE_DIGIT_CLEARING_NO.includes(bank) ||
    (bank === CONSTANTS.SE.BANKS.SWEDBANK && parseInt(val.substr(0, 1)) === 8)
  ) {
    clearingNoLength = 5
  }

  if (val.length <= clearingNoLength) return val

  const clearingNumber = val
    .substr(0, clearingNoLength)

  const accountNumber = val
    .substr(clearingNoLength)

  return `${clearingNumber} ${accountNumber}`
}

module.exports = { accountNo }
